import React from 'react';
import NotiIcon from './noti-icon.component';

const NoResults = () => {
  return (
    <div className="no-results">
      <NotiIcon className="no-results__icon" />
      <p className="no-results__text">
        No result found. Please check the information you have entered and try again, or refer to the CLC / Law Society website to confirm the firms status.
      </p>
    </div>
  );
};

export default NoResults;
